module.exports = __webpack_public_path__ + "static/appstore-de-4d439ebf38d18d51137a0c2c7e957931.png";